import { STAFF_ROLES } from "@shared/core/types";
import type { WebModule } from "../../core/modules";
import { ImportsPage } from "./routes/imports";
import { ReviewPage } from "./routes/review";
import { LotsPage } from "./routes/lots";
import { LotPage } from "./routes/lot";
import { VivierPage } from "./routes/vivier";
import { AssistantPage } from "./routes/assistant";

const xExtraction: WebModule = {
  name: "x-extraction",
  routes: [
    { path: "/analyse", element: <LotsPage />, roles: STAFF_ROLES },
    { path: "/analyse/:id", element: <LotPage />, roles: STAFF_ROLES },
    { path: "/vivier", element: <VivierPage />, roles: STAFF_ROLES },
    { path: "/assistant", element: <AssistantPage />, roles: STAFF_ROLES },
    { path: "/importations", element: <ImportsPage />, roles: STAFF_ROLES },
    { path: "/importations/:id", element: <ReviewPage />, roles: STAFF_ROLES },
  ],
  nav: [
    {
      title: "Analyse des CV",
      order: 11,
      roles: STAFF_ROLES,
      items: [
        { to: "/analyse", label: "Analyse de CV", icon: "checklist", end: false },
        { to: "/vivier", label: "Vivier", icon: "users", end: true },
        { to: "/assistant", label: "Assistant", icon: "message", end: true },
        { to: "/importations", label: "Importer des CV", icon: "sparkles", end: false },
      ],
    },
  ],
};

export default xExtraction;
